// src/api/historyAdminRegisters.ts
import { collection, getDocs, query, where, addDoc, orderBy } from "firebase/firestore";
import { auth, db } from "../firebase";

const COLLECTION_NAME = "historyAdminRegisters";

// Pobranie wszystkich rejestracji adminów
export const getAllAdminRegisters = async (): Promise<HistoryAdminRegisters[]> => {
    const querySnapshot = await getDocs(collection(db, COLLECTION_NAME));
    return querySnapshot.docs.map(doc => ({ id: doc.id, ...(doc.data() as Omit<HistoryAdminRegisters, 'id'>) }));
};

// Pobranie rejestracji dla konkretnego admina
export const getRegistersByAdminId = async (adminId: string): Promise<HistoryAdminRegisters[]> => {
    const q = query(
        collection(db, COLLECTION_NAME),
        where("adminId", "==", adminId),
        orderBy("date", "desc")
    );
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({ id: doc.id, ...(doc.data() as Omit<HistoryAdminRegisters, 'id'>) }));
};

export const addAdminRegister = async (
    register: Omit<HistoryAdminRegisters, "id">
): Promise<HistoryAdminRegisters | null> => {
    if (!auth.currentUser) return null;

    try {
        const docRef = await addDoc(collection(db, COLLECTION_NAME), register);
        return { id: docRef.id, ...register };
    } catch (error: any) {
        if (error?.code === "permission-denied" && !auth.currentUser) {
            return null;
        }
        throw error;
    }
};